import * as firebase from 'firebase/compat/app';

export class User {
  constructor(public user: firebase.default.User, public isAdmin: boolean) { }
}
